import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './EventsPage.css';
import poster1 from '../../assets/qbronze188.jpeg';
import poster2 from '../../assets/WQD.png';
import poster3 from '../../assets/qsolve.png';
import poster4 from '../../assets/qff.png';
import poster5 from '../../assets/kqaf.jpg';
import poster6 from '../../assets/meetup1.png';
import poster7 from '../../assets/webinar1.jpeg';
import poster8 from '../../assets/webinar2.png';
import poster9 from '../../assets/aqs.jpg';
import poster10 from '../../assets/poster.jpg';
import poster11 from '../../assets/qff25.jpg';
import poster12 from '../../assets/series01.jpg';
import poster13 from '../../assets/meetup2.png';
import poster14 from '../../assets/iyq.png';
import poster15 from '../../assets/wiq.jpg';
import poster16 from '../../assets/ilab.jpg';
import poster17 from '../../assets/abu_dhabi.jpeg';
import poster18 from '../../assets/whitepaper.png';
import {
  Video, Users, Globe, ExternalLink, Mail, MapPin,
} from 'lucide-react';

const UPCOMING_EVENTS = [
  {
    id: 15, name: 'Ai Everything Abu Dhabi',
    dateLabel: 'October 6-7, 2026',
    location: 'ADNEC Centre, Abu Dhabi',
    format: 'Physical',
    image: poster17,
    link: 'https://visit.aieverythingabudhabi.com/?utm_source=partnersocial&utm_mediumPartner=&utm_campaignvisprom= ',
  },
  {
    id: 16, name: 'Quantum White Paper Dialogue',
    dateLabel: 'October 16, 2026',
    location: 'Virtual',
    format: 'Online',
    image: poster18,
    link: 'https://luma.com/QuantumKe',
  },
  {
    id: 17, name: 'Qiskit Fall Fest Nairobi 2026',
    dateLabel: 'October 1-24, 2026',
    location: 'University of Nairobi, Kenya',
    format: 'Physical',
    image: poster4,
    link: 'https://qiskitfallfestnairobi.quantumke.org/',
  },
  {
    id: 18, name: 'Kenya Quantum Forum 2026',
    dateLabel: 'November 11, 2026',
    location: 'Raddion Blu Upperhill, Kenya',
    format: 'Physical',
    image: poster5,
    link: 'https://kqaf.quantumke.org/',
  },
  {
    id: 19, name: 'End-Year Quantum Mixer',
    dateLabel: 'November 21, 2026',
    location: 'Nairobi, Kenya',
    format: 'Physical',
    image: poster10,
    link: 'https://luma.com/QuantumKe',
  },
];

const PAST_EVENTS = [
  {
    id: 14, name: 'QSolve Quantathon',
    dateLabel: 'September 1-3, 2026',
    location: 'Strathmore University, Kenya',
    format: 'Physical',
    image: poster3,
    link: 'https://qsolve.org/',
  },
  {
    id: 13, name: 'Entanglement Saturday',
    dateLabel: 'July 25, 2026',
    location: 'Blockchain Center NBO, Kenya',
    format: 'Physical',
    image: poster6,
    link: 'https://luma.com/QuantumKe',
  },
  {
    id: 12, name: 'Demistifying Quantum Computing with iLab Africa',
    dateLabel: 'July 22, 2026',
    location: 'Online',
    format: 'Virtual',
    image: poster16,
    link: 'https://ilabafrica.strathmore.edu/demystifying-quantum-computing/',
  },
  {
    id: 11, name: 'QBronze188 Workshop by QKenya',
    dateLabel: 'May 21–22, 2026',
    location: 'Online',
    format: 'Virtual',
    image: poster1,
    link: 'https://qworld.net/qbronze188/',
  },
  {
    id: 10, name: 'Entanglement Saturday',
    dateLabel: 'April 25, 2026',
    location: 'Node NBO Gigiri, Kenya',
    format: 'Physical',
    image: poster6,
    link: 'https://luma.com/ofbtnpvn',
  },
  {
    id: 9, name: 'Intersection of Quantum & AI with ActionLab Africa',
    dateLabel: 'April 22, 2026',
    location: 'Online',
    format: 'Virtual',
    image: poster7,
    link: 'https://luma.com/uwhkjgva',
  },
  {
    id: 8, name: 'World Quantum Day',
    dateLabel: 'Apr 14, 2026',
    location: 'Nairobi, Kenya',
    format: 'Physical',
    image: poster2,
    link: 'https://worldquantumday.org/',
  },
  {
    id: 7, name: 'Applications of Quantum Computing',
    dateLabel: 'March 19, 2026',
    location: 'Online',
    format: 'Virtual',
    image: poster8, 
    link: 'https://luma.com/qt74tylg',
  },
  {
    id: 6, name: 'IYQ Closing Ceremony',
    dateLabel: 'Feb 10–20, 2026',
    location: 'Online',
    format: 'Virtual',
    image: poster14,
    link: 'https://www.un.org/en/observances/international-year-of-quantum-science-and-technology',
  },
  {
    id: 5, name: 'Africa Quantum Summit: Kenya Edition',
    dateLabel: 'December 4–5, 2025',
    location: 'PrideInn Azure Hotel, Nairobi',
    format: 'Physical',
    image: poster9,
    link: 'https://www.africaquantumsummit.com/',
  },
  {
    id: 4, name: 'Nairobi Qiskit Fall Fest 2025',
    dateLabel: 'October 5-18, 2025',
    location: 'Strathmore University, Nairobi',
    format: 'Physical',
    image: poster11,
    link: 'https://nairobi-qiskit-fallfest.quantumke.org/',
  },
   {
    id: 3, name: 'Demystifying Quantum Series',
    dateLabel: 'September 24, 2025',
    location: 'Online',
    format: 'Virtual',
    image: poster12,
    link: 'https://luma.com/caap2r9i',
  },
  {
    id: 2, name: 'Women in Tech Day',
    dateLabel: 'Apr 14, 2025',
    location: 'Nairobi, Kenya',
    format: 'Physical',
    image: poster15,
    link: 'https://quantumke.org/community',
  },
  {
    id: 1, name: 'Quantum Demo Day',
    dateLabel: 'Mar 27, 2025',
    location: 'Nairobi, Kenya',
    format: 'Physical',
    image: poster10,
    link: 'https://quantumke.org/community',
  },
];

const EventCard = ({ event }) => (
  <div className="ev-card">
    <div className="ev-card-img-wrap">
      <img src={event.image} alt={event.name} className="ev-card-img" />
    </div>
    <div className="ev-card-body">
      <h3 className="ev-card-title">{event.name}</h3>
      <p className="ev-card-date">{event.dateLabel}</p>
      <p className="ev-card-location">
        <MapPin size={12} />
        {event.location}
      </p>
      <a
        href={event.link}
        target="_blank"
        rel="noopener noreferrer"
        className="ev-card-link"
      >
        Learn More <ExternalLink size={12} />
      </a>
    </div>
  </div>
);

const EventsPage = () => {
  const [activeTab, setActiveTab] = useState('upcoming');

  const events = activeTab === 'upcoming' ? UPCOMING_EVENTS : PAST_EVENTS;

  return (
    <div className="events-page">
      <Helmet>
        <title>Events | QuantumKE</title>
        <meta name="description" content="Browse upcoming and past QuantumKE events — workshops, meetups, hackathons, and summits advancing quantum science across Kenya and Africa." />
        <link rel="canonical" href="https://quantumke.org/events" />
      </Helmet>

      {/* ── Banner ── */}
      <section className="events-banner">
        <div className="events-banner-overlay" />
        <div className="events-banner-content">
          <h1 className="events-banner-title">Community Events</h1>
          <p className="events-banner-subtitle">
            Discover workshops, meetups, hackathons, and special events from the QuantumKE community.
          </p>
        </div>
      </section>

      {/* ── Events Cards ── */}
      <section className="events-cards-section">
        <div className="events-container">
          <div className="ev-header">
            <h2 className="ev-header-title">Events</h2>
            <p className="ev-header-subtitle">
              From hands-on workshops to global summits — explore everything happening in Kenya's quantum community.
            </p>
            <div className="ev-tabs">
              <button
                className={`ev-tab${activeTab === 'upcoming' ? ' active' : ''}`}
                onClick={() => setActiveTab('upcoming')}
              >
                Upcoming ({UPCOMING_EVENTS.length})
              </button>
              <button
                className={`ev-tab${activeTab === 'past' ? ' active' : ''}`}
                onClick={() => setActiveTab('past')}
              >
                Past ({PAST_EVENTS.length})
              </button>
            </div>
          </div>

          <div className="ev-grid">
            {events.map(ev => (
              <EventCard key={ev.id} event={ev} />
            ))}
          </div>
        </div>
      </section>

      {/* ── Quantum Happy Hour ── */}
      <section className="events-happyhour-section">
        <div className="events-container">
          <div className="events-section-header">
            <h2 className="events-section-title">Quantum Happy Hour</h2>
            <p className="events-section-description">
              Our weekly community gathering — every Friday, free, and open to all.
            </p>
          </div>

          <div className="events-happyhour-layout">
            <div className="events-hh-poster">
              <img src={poster13} alt="Quantum Happy Hour" className="events-hh-poster-img" />
            </div>

            <div className="events-hh-info">
              <div className="events-hh-badge-row">
                <span className="events-hh-badge">Every Friday</span>
                <span className="events-hh-badge free">Free to Join</span>
                <span className="events-hh-badge online">Online</span>
              </div>

              <h3 className="events-hh-info-title">Your Weekly Dose of Quantum</h3>

              <p className="events-hh-info-desc">
                Quantum Happy Hour is our flagship weekly gathering — a relaxed, open session where
                quantum enthusiasts, beginners, and experts come together to discuss quantum topics,
                share discoveries, ask questions, and build meaningful connections.
              </p>
              <p className="events-hh-info-desc">
                Whether you're just starting your quantum journey or you're a seasoned researcher,
                Happy Hour is the perfect space to engage, learn, and grow within Africa's
                fastest-growing quantum community.
              </p>

              <div className="events-hh-features">
                <div className="events-hh-feature">
                  <div className="events-hh-feature-icon"><Users size={20} /></div>
                  <div>
                    <strong>Open to All</strong>
                    <p>No prerequisites — just curiosity and an open mind</p>
                  </div>
                </div>
                <div className="events-hh-feature">
                  <div className="events-hh-feature-icon"><Video size={20} /></div>
                  <div>
                    <strong>Online &amp; Free</strong>
                    <p>Join from anywhere across Africa and the world</p>
                  </div>
                </div>
              </div>

              <div className="events-hh-contact">
                <Mail size={14} />
                <span><a href="mailto:events@quantumke.org" className="events-hh-contact-link">events@quantumke.org</a></span>
              </div>

              <a href="/join-community" className="events-hh-cta">
                Join the Community
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── Meetups & Webinars ── */}
      <section className="events-meetups-section">
        <div className="events-container">
          <div className="events-section-header">
            <h2 className="events-section-title">Meetups &amp; Webinars</h2>
            <p className="events-section-description">
              Beyond our flagship events, we host in-person meetups and online webinars
              throughout the year to keep the community connected and learning.
            </p>
          </div>

          <div className="events-meetups-grid">
            <div className="events-meetup-card">
              <div className="events-meetup-icon-wrap blue">
                <Users size={26} />
              </div>
              <h3 className="events-meetup-title">Community Meetups</h3>
              <p className="events-meetup-desc">
                In-person gatherings across Kenya where quantum enthusiasts connect, collaborate,
                and share ideas. We host meetups in Nairobi and at university campuses nationwide.
              </p>
              <ul className="events-meetup-features">
                <li>Networking with quantum professionals</li>
                <li>Lightning talks and live presentations</li>
                <li>Hands-on demos and experiments</li>
                <li>Campus chapter meetups across Kenya</li>
              </ul>
            </div>

            <div className="events-meetup-card">
              <div className="events-meetup-icon-wrap teal">
                <Video size={26} />
              </div>
              <h3 className="events-meetup-title">Online Webinars</h3>
              <p className="events-meetup-desc">
                Expert-led online sessions covering quantum computing topics from fundamentals
                to cutting-edge research. Accessible to anyone with an internet connection, anywhere.
              </p>
              <ul className="events-meetup-features">
                <li>Guest lectures from global quantum experts</li>
                <li>Research paper deep-dives</li>
                <li>Industry applications and case studies</li>
                <li>Live Q&amp;A with researchers</li>
              </ul>
            </div>

            <div className="events-meetup-card">
              <div className="events-meetup-icon-wrap purple">
                <Globe size={26} />
              </div>
              <h3 className="events-meetup-title">Special Events</h3>
              <p className="events-meetup-desc">
                From International Year of Quantum celebrations to partner events and awareness
                campaigns, we participate in and organize special activities year-round.
              </p>
              <ul className="events-meetup-features">
                <li>World Quantum Day celebrations</li>
                <li>IYQ 2025 special sessions</li>
                <li>Panel discussions and forums</li>
                <li>Quantum outreach programs</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ── Demystify Quantum Video Series ── */}
      <section className="events-video-section">
        <div className="events-container">
          <div className="events-section-header">
            <span className="events-series-badge">Video Series</span>
            <h2 className="events-section-title">Demystify Quantum</h2>
            <p className="events-section-description">
              Our video series breaking down complex quantum concepts into accessible,
              engaging content for everyone — no physics degree required.
            </p>
          </div>

          <div className="events-video-layout">
            <div className="events-video-wrapper">
              <div className="events-video-embed">
                <iframe
                  src="https://www.youtube.com/embed/nFT-fOUNiXU?si=LgWT9h8T7d7mXWLl"
                  title="Introduction to Quantum Computing — Demystify Quantum"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
            </div>

            <div className="events-video-info">
              <span className="events-video-episode">Episode 1</span>
              <h3 className="events-video-title">Introduction to Quantum Computing</h3>
              <p className="events-video-desc">
                Start your quantum journey with this beginner-friendly introduction. Explore the
                foundational concepts of quantum computing — qubits, superposition, and
                entanglement — explained in plain language with real-world analogies.
              </p>
              <p className="events-video-desc">
                Part of our <em>Demystify Quantum</em> series, designed to make quantum computing
                accessible to everyone, regardless of background or prior knowledge.
              </p>
              <a
                href="https://www.youtube.com/@QuantumKE"
                target="_blank"
                rel="noopener noreferrer"
                className="events-video-cta"
              >
                <Video size={15} /> Watch More on YouTube
              </a>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default EventsPage;
